import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import Input from 'components/shared/input/Input';
import { Field, reduxForm } from 'redux-form';
import './NewPurchaseOrderForm.css';
import uploadSvg from 'images/upload.svg';
import Dropzone from 'react-dropzone';
import DocumentLink from 'components/shared/document/DocumentLink';
import removeSvg from 'images/remove.svg';

class NewPurchaseOrderForm extends Component {
  renderDocument = (props) => {
    if (props.input.value === '') {
      return (
        <Dropzone
          accept="application/pdf, .doc, .docx, .xls, .xlsx"
          className="dropzone-container"
          multiple={false}
          onDrop={(files) => props.input.onChange(files[0])}
        >
          <span>Please drag and drop any file into this area</span>
          <img src={uploadSvg} alt="upload" />
        </Dropzone>
      );
    }
    return (
      <div className="file-viewer">
        <DocumentLink
          file={props.input.value}
          showIcon={false}
          showLink={true}
        />
        <img
          src={removeSvg}
          alt="remove"
          onClick={() => props.input.onChange('')}
        />
      </div>
    );
  };

  renderInput = (props) => {
    return (
      <Input
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  render() {
    return (
      <div className="new-purchase-order-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Number
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderInput}
                name="number"
                placeholder="Number"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Amount
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderInput}
                name="amount"
                placeholder="Amount"
                type="number"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Document
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderDocument}
                name="document"
                placeholder="Document"
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to create a Purchase
              Order.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value="Create"
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.number) {
    errors.number = 'Required';
  }
  if (!values.amount) {
    errors.amount = 'Required';
  }
  if (!values.document) {
    errors.document = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'NewPurchaseOrderForm',
  validate,
})(NewPurchaseOrderForm);



// WEBPACK FOOTER //
// ./src/components/admin/purchase-orders/NewPurchaseOrderForm.js